import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import HowWeWork from "./components/HowWeWork";
import About from "./components/About";
import Services from "./components/Services";
import Portfolio from "./components/Portfolio";
import Team from "./components/Team";
import Careers from "./components/Careers";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import useReveal from "./hooks/useReveal";
import PortfolioDetail from "./pages/PortfolioDetail";
import ServiceDetail from "./pages/ServiceDetail";
import CareerDetail from "./pages/CareerDetail";
import Approach from "./pages/Approach";

// Feature flag: Testimonials ("Voices") section is hidden from the live site
// until real client quotes exist. Set to `true` to re-enable — this will also
// restore the "Voices" nav link (see components/Navbar.jsx SHOW_TESTIMONIALS).
const SHOW_TESTIMONIALS = false;

const Landing = () => {
  useReveal();
  return (
    <main className="min-h-screen bg-[#F7F5F0] text-[#1C1C19] overflow-x-hidden">
      <Navbar />
      <Hero />
      <Marquee />
      <About />
      <HowWeWork />
      <Services />
      <Portfolio />
      <Team />
      {SHOW_TESTIMONIALS && <Testimonials />}
      <Careers />
      <Contact />
      <Footer />
    </main>
  );
};

// Scroll to top on route change (unless there's a hash)
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);
  return null;
};

const toasterOptions = {
  style: {
    background: "#1C1C19",
    color: "#F7F5F0",
    border: "1px solid #2A3439",
    fontFamily: "Manrope, sans-serif",
  },
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/portfolio/:slug" element={<PortfolioDetail />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/careers/:slug" element={<CareerDetail />} />
          <Route path="/approach" element={<Approach />} />
        </Routes>
        <Toaster position="bottom-right" toastOptions={toasterOptions} />
      </BrowserRouter>
    </div>
  );
}

export default App;
